import script from "./AdController.vue?vue&type=script&setup=true&lang=js"
export * from "./AdController.vue?vue&type=script&setup=true&lang=js"

import "./AdController.vue?vue&type=style&index=0&id=b3f99360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f99360"]])

export default __exports__